import "./style.scss";

import { useRef } from "react";
import { CSSTransition } from "react-transition-group";

import variables from "../../../assets/styles/_variables.module.scss";
import StyledButton from "../StyledButton";

interface PopoverMenuProps {
    showPopover: boolean;
    data: any;
    // {
    //     [key: string]: {
    //         label: string,
    //         icon: ReactElement,
    //         action: Function
    //     }[]
    // }[]
}

export const whiteButton = {
    "&.MuiButton-root": {
        color: "black",
        backgroundColor: "white",
        border: `1px solid ${variables["border-grey"]}`,
        borderRadius: variables["border-radius"],
        padding: 0,
    },
};

const PopoverMenu = (props: PopoverMenuProps) => {
    const { showPopover, data } = props;
    const nodeRef = useRef(null);

    return (
        <CSSTransition nodeRef={nodeRef} in={showPopover} timeout={200} classNames="tags-selector" unmountOnExit>
            <div className="popover-menu-actions" ref={nodeRef}>
                {data &&
                    Object.entries(data).map(([key, value]: any) => (
                        <div key={key}>
                            <div className="popover-menu-actions-title">{key}</div>
                            {value &&
                                value.map((item: any) => {
                                    return (
                                        <StyledButton
                                            onClick={item.action}
                                            key={item.label}
                                            disabled={item?.actionDisabled ?? false}
                                            sx={{
                                                ...whiteButton,
                                                display: "flex",
                                                gap: "8px",
                                                minHeight: "100%",
                                            }}
                                        >
                                            {item.icon}
                                            <span className="popover-menu-actions-label">{item.label}</span>
                                        </StyledButton>
                                    );
                                })}
                        </div>
                    ))}
            </div>
        </CSSTransition>
    );
};

export default PopoverMenu;
